import React, { Component } from 'react'
import injectSheet from 'react-jss'
import Color from 'color'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { flexUtils, palette } from '../../../Theme/Theme'
import * as Actions from '../../../Actions/Actions'
// import ReactGA from 'react-ga'
import { isMobile } from "react-device-detect";

class EditPlan extends Component {
    constructor (props) {
        super(props)
        this.state = {
            activePlan: props.user.payments ? props.user.payments.plan : null,
            loading: false,
            monthlyPrices: {
                basic: '2.99',
                premium: '5.99'
            },
            yearlyPrices: {
                basic: '29.99',
                premium: '59.99'
            },
            selected: 'monthly'
        }
    }

    render () {
        const { classes } = this.props
        const { Body, Plan, ActivePlan, PlanHeader, ActionContainer, CancelButton, SubmitButton } = classes     
        return (
            <div className={Body}>
                <div className={classes.ChangePlanHeader}>
                    <div onClick={()=>{this.setState({selected: 'monthly'})}} style={{color:this.state.selected === 'monthly' ? palette.blue : palette.white}} className={classes.Option}>monthly</div> | <div onClick={()=>{this.setState({selected: 'yearly'})}} style={{color:this.state.selected === 'yearly' ? palette.blue : palette.white}} className={classes.Option}>yearly</div> 
                </div>
                <div className={this.state.activePlan === 'hdmonth1' || this.state.activePlan === 'hdannual1' ? ActivePlan : Plan} onClick={this.setPlanBasic}>
                    <div className={PlanHeader}>
                        <h3>Basic</h3>
                        <h3>{this.state.selected === 'monthly' ? '$2.99' : '$29.99'}</h3>                        
                    </div>
                    <span><i className="fas fa-check-circle" style={{fontSize: '1rem',marginRight: '.5rem', color: Color(palette.white)}}/>Full Access to the Entire Spectiv Library</span>
                    <span><i className="fas fa-check-circle" style={{fontSize: '1rem',marginRight: '.5rem', color: Color(palette.white)}}/>Unlimited Streaming</span>
                    <span><i className="fas fa-check-circle" style={{fontSize: '1rem',marginRight: '.5rem', color: Color(palette.white)}}/>Full High Definition Video Quality</span>
                </div>
                <div className={this.state.activePlan === '4kmonth1' || this.state.activePlan === '4kannual1'? ActivePlan: Plan} onClick={this.setPlanPremium}>
                    <div className={PlanHeader}>
                        <h3>Premium</h3>
                        <h3>{this.state.selected === 'monthly' ? '$5.99' : '$59.99'}</h3>
                    </div>
                    <span><i className="fas fa-check-circle" style={{fontSize: '1rem',marginRight: '.5rem', color: Color(palette.white)}}/>Full Access to the Entire Spectiv Library</span>
                    <span><i className="fas fa-check-circle" style={{fontSize: '1rem',marginRight: '.5rem', color: Color(palette.white)}}/>Unlimited Streaming</span>
                    <span><i className="fas fa-check-circle" style={{fontSize: '1rem',marginRight: '.5rem', color: Color(palette.white)}}/>4K Ultra High Definition Video Quality</span>
                    <span><i className="fas fa-check-circle" style={{fontSize: '1rem',marginRight: '.5rem', color: Color(palette.white)}}/>HDR (High Dynamic Range)</span>
                </div>
                <div className={ActionContainer}>
                    <button className={CancelButton} onClick={this.onCancel}>Cancel</button>
                    <button className={SubmitButton} onClick={this.onSubmit}>{this.state.loading ? <i className="fas fa-spinner fa-spin"/> : 'Submit'}</button>
                </div>
            </div>
        )
    }

    componentDidMount () {
        // ReactGA.pageview('/Home/EditPlan');
    }        

    setPlanBasic = () => {
        if (this.state.selected === 'monthly') {
            this.setState({ activePlan: 'hdmonth1' })
        } else {
            this.setState({ activePlan: 'hdannual1'})
        }            
    }

    setPlanPremium = () => {
        if (this.state.selected === 'monthly') {
            this.setState({ activePlan: '4kmonth1' })
        } else {
            this.setState({ activePlan: '4kannual1'})
        }        
    }

    onCancel = () => {
        this.props.history.push('/Home/AccountInfo')
    }

    onSubmit = () => {
        const { user, dispatch, history } = this.props
        this.setState({ loading: true })
        const data = {
            payments: {
                platform: 'stripe',
                plan: this.state.activePlan
            }
        }
        dispatch(Actions.updateUser(user.token, data, history))
    }
}

const styles = {
    ...flexUtils,
    ChangePlanHeader: {
        extend: 'Plan',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        color: palette.lightFont,
        '&:hover':{
            cursor: 'auto',
            backgroundColor: 'black'
        }
    },    
    Option: {
        transition: 'all .4s',
        color: palette.lightFont,
        width: '40%',
        textAlign: 'center',
        '&:hover':{
            cursor: 'pointer',
            color: palette.blue
        }
    },
    Body: {
        paddingTop: '1rem',
        composes: ['$FlexColumn'],
        justifyContent: 'flex-start',
        flex: '1',
        width: '100%',
        maxWidth: '30rem',
        marginTop: '10vh'
    },
    Plan: {
        composes: ['$FlexColumn'],
        // background: 'rgba(200, 200, 200, 0.1)',
        minHeight: '4rem',
        padding: '.5rem 1rem',
        borderRadius: '5px',
        transition: 'all .5s',
        '& h3': {
            color: palette.white,
            fontSize: '2rem',
            padding: '.5rem',
            textAlign: 'center'
        },
        '& span': {
            color: palette.white,
            padding: '.5rem'
        },
        '&:hover': {
            background: Color(palette.blue).alpha(0.3).toString(),
            cursor: 'pointer'
        }
    },
    PaymentPeriod: {
        // background: 'rgba(200, 200, 200, 0.1)',
        minHeight: '4rem',
        padding: '.5rem 1rem',
        borderRadius: '5px',
        transition: 'all .5s',
        '& h3': {
            color: palette.white,
            fontSize: '2rem',
            padding: '.5rem',
            textAlign: 'center'
        },
        '& span': {
            color: palette.white,
            padding: '.5rem'
        },
    },
    PlanHeader: {
        composes: '$FlexRow',
        justifyContent: 'space-between'
    },
    ActivePlan: {
        composes: '$Plan',
        background: Color(palette.blue).alpha(0.3).toString(),
        '&:hover': {
            background: Color(palette.blue).alpha(0.3).toString(),
            cursor: 'default'
        }
    },
    ActionContainer: {
        composes: ['$FlexRow'],
        justifyContent: 'center',
        marginTop: '.5rem',
        alignItems: 'center',
        width: '100%',
        maxWidth: '30rem',
        height: '4rem'
    },
    Button: {
        margin: '1rem',
        height: '2.5rem',
        width: '12rem',
        border: 'none',
        borderRadius: '3px',
        fontSize: '1.1rem',
        transition: 'all .2s',
        '&:hover': {
            cursor: 'pointer'
        },
        '&:focus': {
            outline: 'none'
        }
    },
    CancelButton: {
        composes: '$Button',
        '&:hover': {
            background: 'rgb(190, 190, 190)'
        }
    },
    SubmitButton: {
        composes: '$Button',
        background: palette.blue,
        color: palette.lightFont,
        '&:hover': {
            background: `${Color(palette.blue).darken(0.2)}`
        }
    }
}

const mapStateToProps = state => {
    return {
        user: state.mainState.user
    }
}

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(EditPlan)))


// WEBPACK FOOTER //
// ./src/js/Components/Home/Settings/EditPlan.jsx